module.exports = __webpack_public_path__ + "img/contributions10Off.198fd431.svg";